export class EndedCallIdRegistry {
  private readonly ended = new Set<string>();

  remember(chatId: string, callId: string): void {
    this.ended.add(`${chatId}\u0000${callId}`);
  }

  has(chatId: string, callId: string): boolean {
    return this.ended.has(`${chatId}\u0000${callId}`);
  }
}

/** Prevents a stale async completion from releasing a newer accept attempt. */
export class AsyncAttemptGate {
  private sequence = 0;
  private activeAttempt: number | null = null;

  begin(): number | null {
    if (this.activeAttempt !== null) return null;
    const attempt = ++this.sequence;
    this.activeAttempt = attempt;
    return attempt;
  }

  isCurrent(attempt: number): boolean {
    return this.activeAttempt === attempt;
  }

  finish(attempt: number): void {
    if (this.activeAttempt === attempt) this.activeAttempt = null;
  }

  cancel(): void {
    this.sequence++;
    this.activeAttempt = null;
  }
}

export function mayStartIncomingV2Call(chatId: string, callId: string, ended: EndedCallIdRegistry): boolean {
  return !ended.has(chatId, callId);
}
